import React,{useEffect,useState} from "react"
import Loading from "../components/Loading";
import { formatDate,toPesos } from "../components/Utilities";
import OrderStatus from "../components/OrderStatus";
import post from '../post';
import Alert from "../components/Alert";
import {useLocation as location2} from 'wouter';
import cn from 'classnames';
 const Component = () => {
    const [data,setData]=useState(null);
    const [alert,setAlert]=useState({isOpen:false});
    const [location,navigate]=location2();
    const [orderId,setOrderId]=useState(0);

    useEffect(()=>{
        const getData=async ()=>{
            const c=await post('getOrders');
            if(!c.result){
                setAlert({isOpen:true,title:'Error',message:'Error al cargar historial. Intenta de nuevo más tarde.',onClose:()=>{navigate('/profile')}});
                return;
            }
            setData(c.data);
        }
        getData();
    },[])

    return (
        <div id="webcrumbs">
            <Alert isOpen={alert?.isOpen} title={alert?.title} message={alert?.message} onClose={alert?.onClose || (() => setAlert({ isOpen: false, title: '', message: '' }))} />
            <OrderStatus isOpen={orderId} onClose={() => setOrderId(0)}  />
            <div className="min-h-screen bg-gradient-to-b from-primary-50 to-white relative pb-16 flex flex-col items-center justify-center">
                <div className="w-full max-w-4xl px-6 py-10">
                    <div className="absolute top-4 left-4">
                        <button className="flex items-center justify-center p-2 bg-white rounded-full shadow-sm border border-neutral-100 hover:bg-neutral-50 transition-all transform hover:scale-105 active:scale-95"
                            onClick={() => navigate('/profile')}
                        >
                            <span className="material-symbols-outlined text-neutral-700">arrow_back</span>
                        </button>
                    </div>
                    <div className="flex flex-col items-center mb-8">
                        <div className={cn("w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mb-4 shadow-lg transform hover:rotate-12 transition-all")}>
                            <span className="material-symbols-outlined text-white text-3xl">receipt_long</span>
                        </div>
                        <h1 className="text-3xl font-bold text-neutral-900 mb-1">Historial de Pedidos</h1>
                        <p className="text-neutral-600 text-center">
                            Consulte sus pedidos anteriores y su estado actual
                        </p>
                    </div>

                    <div className="bg-white rounded-md shadow-sm border border-neutral-100  mb-6 backdrop-blur-sm">
                        
                        <div className="space-y-4">
                            {data && data.map(el=>{
                                const total=el.lineas?.filter(el=>el.estatus!='cancelado').reduce((acc,linea)=>acc+((+linea.precio)+(+linea.precio_extras))*linea.q,0);
                                return (<div 
                                    key={"order-"+el.id}
                                    className="border-b border-neutral-100  p-4 hover:border-primary-200 transition-all hover:bg-neutral-50">
                                <div className="flex justify-between items-start mb-3">
                                    <div className="flex items-center">
                                        <span className={cn("bg-green-100 text-green-700 text-xs font-medium px-2.5 py-0.5 rounded-full",el.estatus=='closed'?'bg-green-100 text-green-700':el.estatus=='open'?'bg-yellow-100 text-yellow-700':el.estatus=='pay'?'bg-blue-100 text-blue-700':el.estatus=='canceled'?'bg-red-100 text-red-700':'')}>
                                            {el.estatus=='closed' && 'Cerrado'}
                                            {el.estatus=='open' && 'En proceso'}
                                            {el.estatus=='pay' && 'Esperando pago'}
                                            {el.estatus=='canceled' && 'Cancelado'}
                                        </span>
                                        <p className="ml-2 text-sm text-neutral-500">{formatDate(el.fc)}<br/><small>{el.fc.substring(11,16)}</small></p>
                                    </div>
                                    <p className="font-semibold text-primary-600">${toPesos(total)}</p>
                                </div>
                                <div className="flex justify-between items-center">
                                    <div>
                                        <p className="font-medium text-neutral-900">Pedido #{el.ticket}</p>
                                        
                                    </div>
                                    <button className="text-sm text-primary-600 hover:text-primary-700 flex items-center transition-colors"
                                        onClick={()=>{setOrderId(el.id)}}
                                    >
                                        Ver detalles
                                        <span className="material-symbols-outlined text-sm ml-1">chevron_right</span>
                                    </button>
                                </div>
                            </div>);
                            })}
                            
                        </div>

                        
                    </div>

                    <div className="flex justify-center space-x-4">
                        <button className="flex items-center justify-center px-4 py-2 bg-white border border-neutral-200 text-neutral-800 rounded-xl hover:bg-neutral-50 transition-all shadow-sm"
                            onClick={() => { navigate('/profile') }}
                        >
                            <span className="material-symbols-outlined text-sm mr-1">arrow_back</span>
                            Volver
                        </button>
                        {/*<button className="flex items-center justify-center px-4 py-2 bg-white border border-neutral-200 text-neutral-800 rounded-xl hover:bg-neutral-50 transition-all shadow-sm">
                            <span className="material-symbols-outlined text-sm mr-1">help_outline</span>
                            Ayuda
                        </button>
                        <button className="flex items-center justify-center px-4 py-2 bg-primary-600 text-white rounded-xl hover:bg-primary-700 transition-all shadow-sm">
                            <span className="material-symbols-outlined text-sm mr-1">shopping_cart</span>
                            Realizar pedido
                        </button>*/}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Component;